<template>
  <div class="upload">
    <!--    <img :src="testImage" alt="">-->
    <draggable class="list" v-model="list" undraggable=".add">
      <!-- <transition-group> -->
      <template v-if="list.length">
        <div class="card" v-for="(item, idx) in list" :key="idx">
          <div v-loading="item.loading" class="card-image">
            <!--                        <div v-if="item.loading" class="loading"><i class="el-icon-loading"></i></div>-->
            <img :src="isImage ? getFullImageURL(item.url) : getFullImageURL(item.url, 'video')" :alt="item.url"/>
            <div class="hover" v-if="!disabled">
              <i class="el-icon-delete" @click="removeFile(idx)"></i>
              <template v-if="isShowCrop">
                <i v-if="isImage" class="el-icon-crop" @click="showCropper(idx)"></i>
              </template>
              <i class="el-icon-full-screen" @click="preview(idx)"></i>
              <!--                            <i v-for="(extension, _idx) in extensions" :class="extension.isActive ? extension.activeIcon : extension.icon" @click="extension.click(item, extension)" :style="extension.style ? extension.activeStyle : extension.style" :key="_idx"></i>-->
            </div>
          </div>
          <slot name="bottom" :item="item"></slot>
        </div>
      </template>
      <template>
        <div v-show="list.length < limit" class="card">
          <div ref="addItem" :class="`card-image add ${dragenter ? 'active' : ''}`"><label :for="elId"><i
              class="el-icon-plus avatar-uploader-icon"></i></label></div>
        </div>
      </template>
      <!-- </transition-group> -->
    </draggable>

    <label type="button" class="btn">
		    <span class="choose"
              style="line-height:30px;font-size:14px; width:104px;height:30px; color: #3572E2; border: 1px solid rgba(0,0,0,0.15);  border-radius: 3px;font-size:12px;display:inline-block">
               <i class="el-icon-upload2" style="margin-left:14px;font-size:14px;"></i> <span style="font-size:14px;">上传图片</span></span>
      <input style="width:0" :id="elId" type="file" ref="file" :accept="accept" :multiple="multiple"
             @change="handleInputChange" :disabled="disabled"/>
    </label>
    <span style="margin-left:10px;color: rgba(0, 0, 0, 0.65);">图片最多上传9张</span>
    <el-row v-loading="loadings"></el-row>
    <!-- <el-button type="primary" size="mini">
        <span>上传</span>
        <input :id="elId" type="file" ref="file" :accept="accept" :multiple="multiple" @change="handleInputChange" :disabled="disabled" />
    </el-button> -->
    <el-dialog :visible.sync="previewDialogVisible" class="previewDialog">
      <i v-if="isImage" class="el-icon-arrow-left left_icon" @click="changeActiveUrl('left')"></i>
      <img v-if="isImage" :src="getFullImageURL(activeFile.url)" :alt="activeFile.url" class="preview_img"/>
      <i v-if="isImage" class="el-icon-arrow-right right_icon" @click="changeActiveUrl('right')"></i>
      <video v-if="isVideo" width="100%" :src="getFullVideoURL(activeFile.url)" controls="controls">
        您的浏览器不支持 video 标签。
      </video>
    </el-dialog>
    <el-dialog :visible.sync="cropperVisible" width="850px" :before-close="beforeCloseCropper"
               :closeOnClickModal="false">
      <div style="width: 800px; height: 800px; margin: 0 auto;">
        <vue-cropper ref="cropper" :img="getFullImageURL(activeFile.url)" mode="contain"
                     :auto-crop-width="option.autoCropWidth" :auto-crop-height="option.autoCropHeight"
                     :output-size="option.size" :output-type="option.outputType" :info="true"
                     :full="!autoCropHeight?option.full:false" :fixed="fixed" :enlarge="1"
                     :fixed-number="!autoCropHeight?(isPost?[3,4]:fixedNumber):(scale?scale:[5,1])"
                     :can-move="option.canMove" :can-move-box="option.canMoveBox" :fixed-box="option.fixedBox"
                     :original="option.original" :auto-crop="option.autoCrop" :center-box="option.centerBox"
                     :high="option.high"></vue-cropper>
      </div>

      <div slot="footer" class="dialog-footer">
        <p style="float: left;">* 鼠标滚动可缩放图片</p>
        <el-button type="primary" @click="handleCrop">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {VueCropper} from 'vue-cropper'
import {getFullImageURL, getFullVideoURL} from '@/utils/helper'
import api from "plus/api";

export default {
  name: 'upload',
  components: {draggable, VueCropper},
  props: {
    isPost: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    limit: {type: Number, default: 1},
    multiple: {type: Boolean, default: false},
    type: {type: String, default: 'image'},
    value: {type: [Array, String, Object], default: ''},
    default: {type: [Array, String, Object], default: ''},
    needFileInfo: {type: Boolean, default: false},
    autoShowCrop: {type: Boolean, default: false},
    isCurrentImageCrop: {type: Boolean, default: false},
    autoCropWidth: {type: Number, default: 0},
    autoCropHeight: {type: Number, default: 0},
    extensions: {type: Array, default: () => []},
    scale: {type: Array, default: () => []},
    isShowCrop: {type: Boolean, default: true},
    maxSize: {type: Number, default: 5}
  },
  data() {
    return {
      loadings: false,
      elId: new Date().getTime(),
      file: null,
      list: [],
      fileNames: '',
      activeIdx: 0,
      previewDialogVisible: false,
      cropperVisible: false,
      show: true,
      fixed: true,
      fixedNumber: [1, 1],
      testImage: '',
      option: {
        size: 1,
        full: true,
        outputType: 'png',
        canMove: true,
        fixedBox: false,
        original: true,
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: this.autoCropWidth ? this.autoCropWidth : 480,
        autoCropHeight: this.autoCropHeight ? this.autoCropHeight : 200,
        centerBox: false,
        high: true
      },
      dragenter: false
    }
  },
  computed: {
    activeFile() {
      return this.list[this.activeIdx] ? this.list[this.activeIdx] : {}
    },
    accept() {
      if (this.type === 'video') {
        return 'video/*'
      }
      return 'image/*'
    },
    isImage() {
      return this.type === 'image'
    },
    isVideo() {
      return this.type === 'video'
    }
  },
  watch: {
    list() {
      if (this.limit === 1) {
        if (this.list[0]) {
          // if(!this.autoCropWidth)
          // {

          // }else this.$emit('input', this.list[0].clipped)
          if (this.needFileInfo || this.isCurrentImageCrop) {
            this.$emit('input', this.list[0])
          } else {
            this.$emit('input', this.list[0].url)
          }
        } else {
          this.$emit('input', '')
        }
      } else {
        this.$emit('input', this.list)
      }
    },
    default() {
      if (this.list.length === 0) this.watchValue()
    }
  },
  created() {
    this.watchValue()
  },
  activated() {
    this.clearAll();
  },
  mounted() {
    const dropbox = this.$refs.addItem
    dropbox.addEventListener('drop', this.handleDrop, false)
    dropbox.addEventListener('dragleave', e => {
      e.stopPropagation()
      e.preventDefault()
      this.dragenter = false
    })
    dropbox.addEventListener('dragenter', e => {
      e.stopPropagation()
      e.preventDefault()
      this.dragenter = true
    })
    dropbox.addEventListener('dragover', e => {
      e.stopPropagation()
      e.preventDefault()
      this.dragenter = true
    })
  },
  methods: {
    getFullVideoURL,
    beforeCloseCropper() {
      this.activeIdx = -1
      this.cropperVisible = false
    },
    clearAll() {
      this.list = []
    },
    getFullImageURL,
    watchValue() {
      if (Array.isArray(this.default)) {
        this.list = this.default.map(item => {
          if (typeof item === 'string') {
            return {
              url: item,
              loading: false
            }
          } else {
            return item
          }
        })
      } else {
        if (this.default) {
          if (typeof this.default === 'string') {
            this.list = [{url: this.default}]
          } else {
            if (this.default.hasOwnProperty('url') && this.default.url) {
              this.list = [{...this.default}]
            } else {
              this.list = []
            }
          }
        } else {
          this.list = []
        }
      }
    },
    handleDrop(event) {
      event.preventDefault()
      event.stopPropagation()
      const files = event.dataTransfer.files
      this.checkFileAndUpload(files)
      this.dragenter = false
    },
    handleInputChange(event) {
      const files = event.target.files
      this.checkFileAndUpload(files)
    },
    checkFileSize(file) {
      return file.size / 1024 > this.maxSize * 1024
    },
    checkFileAndUpload(files) {
      const fileLength = this.list.length;
      if (files.length + fileLength > this.limit) return this.$message.error('超出上限，最多上传' + this.limit + "张")


      for (let i = 0, l = files.length; i < l; i++) {
        const fileIdx = i + fileLength
        const file = files[i]

        if (this.checkFileSize(file)) {
          return this.$message.error(`请上传小于${this.maxSize}M的文件`)
        }

        if (this.needFileInfo) {
          this.getFileInfo(file)
              .then(fileInfo => this.initFile(fileIdx, fileInfo))
              .then(() => this.upload(file, fileIdx))
        } else {
          this.initFile(fileIdx)
          this.upload(file, fileIdx)
        }
      }
      this.$refs.file.value = ''
    },
    initFile(idx, fileInfo = {}) {
      this.$set(this.list, idx, {
        url: '',
        loading: true,
        ...fileInfo
      })
    },
    checkIsImage(file) {
      return /\/(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(file.type)
    },
    checkIsGif(file) {
      return /\/(gif)$/.test(file.type)
    },
    getFileInfo(file) {
      if (this.isImage) return this.getImageInfo(file)
      if (this.isVideo) return this.getVideoInfo(file)
    },
    getImageInfo(file) {
      return new Promise((resolve, reject) => {
        const img = document.createElement('img')
        img.src = this.getFileUrl(file)
        img.onload = () => {
          resolve({
            width: img.width || 0,
            height: img.height || 0,
            path: img.src
          })
        }
        img.onerror = reject
      })
    },
    getVideoInfo(file) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file)
        const videoEle = document.createElement('video')
        videoEle.addEventListener('loadedmetadata', () => {
          //URL.revokeObjectURL(url)
          resolve({
            width: videoEle.videoWidth || 0,
            height: videoEle.videoHeight || 0,
            path: url
          })
        })
        videoEle.setAttribute('src', url)
        videoEle.load()
      })

    },
    getFileUrl(file) {
      let url
      const agent = navigator.userAgent
      if (agent.indexOf('MSIE') >= 1) {
        url = file.value
      } else if (agent.indexOf('Firefox') > 0) {
        url = window.URL.createObjectURL(file)
      } else if (agent.indexOf('Chrome') > 0) {
        url = window.URL.createObjectURL(file)
      }
      return url
    },
    showCropper(idx) {
      this.activeIdx = idx
      this.cropperVisible = true
      this.$nextTick(() => {
        this.$refs.cropper.startCrop()
        this.$refs.cropper.goAutoCrop()
      })
    },
    removeFile(idx) {
      this.$emit('on-remove', idx, this.isImage)
      this.list.splice(idx, 1)
    },
    preview(idx) {
      this.activeIdx = idx
      this.previewDialogVisible = true
    },

    handleCrop() {
      let that = this;
      that.$refs.cropper.getCropData(base64 => {
        const arr = base64.split(',')
        const mime = arr[0].match(/:(.*?);/)[1]
        const bstr = atob(arr[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        const file = new File([u8arr], '剪裁.png', {type: mime})
        that.upload(file, that.activeIdx, (that.autoShowCrop && !that.autoCropWidth && !that.isPost ? 'clipped' : undefined))
            .then(() => {
              that.beforeCloseCropper()

            })
      })
    },

    upload(file, fileIdx, key = 'url') {
      this.fileNames = file.name
      let that = this;
      return new Promise((resolve, reject) => {
        let tokenPr
        if (that.isVideo) {
          tokenPr = api.qiniu.getVideoToken()
          // tokenPr = this.$api.qiniu.getToken()
        } else {
          ;
          ;
          tokenPr = api.qiniu.getToken({fileName: that.fileNames})
          // tokenPr = this.$api.qiniu.getToken()
        }

        tokenPr.then(result => {
          let token = result.data.data.token
          let fileName = result.data.data.fileName
          // let { token, fileName } = result.data;
          if (that.checkIsGif(file)) {
            fileName += ".gif";
          } else {
            let index = file.name.lastIndexOf(".");
            let name = file.name.substr(index);
            fileName += name;
          }
          // ;
          const formData = new FormData();
          formData.append('token', token)
          formData.append('key', fileName)
          formData.append('file', file)
          return formData
        })
            .then(formData => api.qiniu.upload(formData))
            .then(result => {
              that.loadings = true
              that.$set(that.list, fileIdx, {
                ...that.list[fileIdx],
                [key]: `${result.data.key}`,
                loading: false,
                type: 'IMAGE'
              })
              if (that.list.length !== 0) {
                that.loadings = false
              }
              that.$nextTick(() => {
                that.autoShowCrop && that.showCropper(fileIdx)
                resolve(result)
              })
            })
            .catch(error => {
              that.removeFile(fileIdx)
              that.$message.error('上传失败')
              console.error(error)
              reject(error)
            })
      })
    },
    changeActiveUrl(type) {

      switch (type) {
        case 'left':
          if (this.list.length > 1) {
            if (this.activeIdx > 0) {
              this.activeIdx--;
            }
          }
          break;
        case 'right':
          if (this.list.length > 1) {
            if (this.activeIdx < this.list.length - 1) {
              this.activeIdx++;
            }
          }
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.upload {
  width: 100%;
  max-width: 400px;

  input[type="file"] {
    position: absolute;
    opacity: 0;
  }

  .list {
    display: flex;
    flex-wrap: wrap;
  }

  .card {
    margin-right: 17px;
    margin-bottom: 20px;
  }

  .card-image {
    flex-shrink: 0;
    position: relative;
    border: 1px dotted #dcdfe6;
    border-radius: 8px;
    height: 110px;
    width: 110px;
    overflow: hidden;
    text-align: center;
    cursor: pointer;

    img {
      width: 100%;
    }

    .loading {
      position: absolute;
      top: 0;
      left: 0;
      text-align: center;
      line-height: 150px;
      width: 100%;
      font-size: 30px;
    }

    .hover {
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      text-align: center;
      line-height: 150px;
      transition: opacity 0.2s linear;

      i {
        margin: 0 5px;
        font-size: 20px;
        color: #fff;
      }
    }

    &:hover .hover {
      opacity: 1;
    }
  }

  .add {
    line-height: 112px;
    text-align: center;
    font-size: 30px;
    transition: all 0.2s linear;

    label {
      display: block;
      width: 100%;
      height: 100%;
    }

    &.active {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
      border: 1px solid rgba(0, 0, 0, 0.5);
    }
  }
}

.previewDialog {
  /deep/ .el-dialog {
    .el-dialog__body {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      i {
        font-size: 36px;
        cursor: pointer;
      }

      img {
        max-width: 95%;
      }
    }
  }
}
</style>
